import { initTdx } from '../../../init/sdkTdx';
import { tdx_request, tdx_response } from "../../../tdx_proto/bundle";
import { getConnectionPool } from '../../../core/connectionPool';
import { hashString } from '../../../utils/hash';

export async function TeamMembers(
    teamName: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.Team_Members.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        teamMembers: tdx_request.Team_Members.create({ pin, data, fromTime, toTime, teamName })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.teamMembers?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get team members ${res?.teamMembers?.status}`);
        }
        return res?.teamMembers?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in TeamMembers request: ' + err);
    }
}

export async function TeamActivityTimeline(
    teamName: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_ActivityTimeline.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        teamActivityTimeline: tdx_request.Team_ActivityTimeline.create({ pin, data, fromTime, toTime, teamName })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.teamActivityTimeline?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get team activity timeline ${res?.teamActivityTimeline?.status}`);
        }
        return res?.teamActivityTimeline?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in TeamActivityTimeline request: ' + err);
    }
}

export async function TeamFilesTouched(
    teamName: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_FilesTouched.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        teamFilesTouched: tdx_request.Team_FilesTouched.create({ pin, data, fromTime, toTime, teamName })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.teamFilesTouched?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get team files touched ${res?.teamFilesTouched?.status}`);
        }
        return res?.teamFilesTouched?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in TeamFilesTouched request: ' + err);
    }
}

export async function TeamMembershipChanges(
    teamName: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.Team_MembershipChanges.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        teamMembershipChanges: tdx_request.Team_MembershipChanges.create({ pin, data, fromTime, toTime, teamName })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.teamMembershipChanges?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get team membership changes ${res?.teamMembershipChanges?.status}`);
        }
        return res?.teamMembershipChanges?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in TeamMembershipChanges request: ' + err);
    }
}

export async function TeamRoleIntersection(
    teamName: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.Team_RoleIntersection.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        teamRoleIntersection: tdx_request.Team_RoleIntersection.create({ pin, data, fromTime, toTime, teamName })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        if (res?.teamRoleIntersection?.status != tdx_response.Status.SUCCESS) {
            throw Error(`failed to get team role intersection ${res?.teamRoleIntersection?.status}`);
        }
        return res?.teamRoleIntersection?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in TeamRoleIntersection request: ' + err);
    }
}

export async function TeamSharingActions(
    teamName: string,
    fromTime: number,
    toTime: number
): Promise<tdx_response.User_SharingActions.IItem[]> {
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();
    let times = 10;
    while (client.is_open() == false && times >= 0) {
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
    if (times < 0) throw new Error("Connection Failed. Please try again.");

    const req = tdx_request.Request.create({
        teamSharingActions: tdx_request.Team_SharingActions.create({ pin, data, fromTime, toTime, teamName })
    });

    try {
        const res = await client.sendAndWait(req);
        client.close();
        return res?.teamSharingActions?.items || [];
    } catch (err) {
        client.close();
        throw Error('Error in TeamSharingActions request: ' + err);
    }
}
